<template>
  <div>
    <MfaPopup @authenticated="fetchDatas"></MfaPopup>
    <h1>{{$route.meta.title}}</h1>
    <div class="my-container">
      <h3>Sélection d'une campagne : </h3>
      <div class="row">
        <!-- Selection campagne -->
        <div class="col-2">
          <select class="form-select" v-model="campaignSelected">
            <option v-for="(cp, ix) in campaigns" :value="cp" :key="ix">{{ cp }}</option>
          </select>
        </div>
        <!-- Validation -->
        <div class="col-2">
          <button class="btn btn-success" v-on:click="generateFolder()">Générer</button>
        </div>
      </div>
      <br />
      <div class="row" v-if="dlLink != ''">
        <div class="col-3">
          <ul class="list-group">
            <li class="list-group-item">
              <a :href="dlLink" target="_blank">Télécharger le fichier</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MfaPopup from "@/components/MfaPopup";
  import { getContractPaymentType } from "@/utils/frs";
  import { getCampaignsYear } from "@/utils/period";

  export default {
    name: "GenerateFolderRfa",
    components: { MfaPopup },
    data() {
      return {
        campaigns: [],
        campaignSelected: 0,
        dlLink: ""
      }
    },
    mounted() {
      this.loadCampaigns();
    },
    watch: {
      
    },
    methods: {
      // Récupération des données
      generateFolder() {
        getContractPaymentType(this.campaignSelected).then(res => {
          this.dlLink = this.$store.state.rootApi + res;
        })
      },

      // Campagnes
      loadCampaigns() {
        getCampaignsYear().then(res => {
          this.campaigns = res;
        })
      },

    },
    computed: {
      
    }
  }
</script>

<style scoped>
  ul > li > a {
    color: black;
    text-decoration: none;
  }

  ul > li > a:hover {
    color: #A7C13C;
  }
</style>



// WEBPACK FOOTER //
// src/pages/RFA/GenerateFolderRfa.vue